'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(Page, _PureComponent);

  function Page() {
    (0, _classCallCheck3.default)(this, Page);
    return (0, _possibleConstructorReturn3.default)(this, (Page.__proto__ || (0, _getPrototypeOf2.default)(Page)).apply(this, arguments));
  }

  (0, _createClass3.default)(Page, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          title = _props.title,
          header = _props.header,
          pullHeaderLeft = _props.pullHeaderLeft;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)('container-fluid', 'page', className) },
        _react2.default.createElement(_reactHelmet2.default, { title: title || header }),
        header && _react2.default.createElement(
          'h1',
          { className: (0, _bind2.default)({ 'pull-left': pullHeaderLeft }) },
          header
        ),
        children
      );
    }
  }]);
  return Page;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
  className: _propTypes2.default.string,
  header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  pullHeaderLeft: _propTypes2.default.bool,
  title: _propTypes2.default.string
}, _class.defaultProps = {
  pullHeaderLeft: false
}, _temp);
exports.default = Page;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/Page.js
// module id = 350
// module chunks = 1